<template>
  <div v-if="isVisible" class="overlay" @click="handleOverlayClick"></div>
  <div v-if="isVisible" class="modal-container">
    <div class="modal-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalContainer",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    closeOnOverlay: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["close"],
  watch: {
    isVisible: {
      handler(newVal) {
        if (newVal) {
          // 모달이 열릴 때 배경 스크롤 방지
          this.preventBackgroundScroll();
        } else {
          // 모달이 닫힐 때 배경 스크롤 복원
          this.restoreBackgroundScroll();
        }
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    // 컴포넌트가 제거될 때 스크롤 복원
    this.restoreBackgroundScroll();
  },
  methods: {
    handleOverlayClick() {
      if (this.closeOnOverlay) {
        this.$emit("close");
      }
    },
    preventBackgroundScroll() {
      // body 스크롤 방지
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.width = "100%";

      // 터치 스크롤도 방지 (모바일)
      document.body.style.overscrollBehavior = "none";
      document.body.style.touchAction = "none";
    },
    restoreBackgroundScroll() {
      // 스크롤 위치 저장
      const scrollY = document.body.style.top;

      // body 스타일 초기화
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overscrollBehavior = "";
      document.body.style.touchAction = "";

      // 원래 스크롤 위치로 복원
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
    },
  },
};
</script>

<style scoped>
/* 모달 오버레이 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 810;
}

/* 모달 컨테이너 */
.modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 820;
  max-height: 90vh;
}

/* 모달 내용 */
.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 90vw;
  min-width: 260px;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}

/* ================================================
   반응형 디자인
   - Large: 1025px ~ (기본 스타일)
   - Medium: 481px ~ 1024px
   - Small: ~ 480px
   ================================================ */

/* Medium (481px ~ 1024px) */
@media screen and (max-width: 1024px) {
  .modal-container {
    max-height: 85vh;
  }

  .modal-content {
    max-width: 380px;
    width: 92vw;
    min-width: 280px;
    max-height: 75vh;
    border-radius: 10px;
  }
}

/* Small (~ 480px) */
@media screen and (max-width: 480px) {
  .modal-container {
    max-height: 80vh;
  }

  .modal-content {
    max-width: 100vw;
    width: 95vw;
    min-width: 260px;
    max-height: 70vh;
    border-radius: 8px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.12);
  }
}
</style>
